import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ChevronIcon from '~/assets/icons/Chevron';

import ProductDescription from './ProductDescription';

const ProductDetailsToggle = ({
  isOpen,
  onClick
}: {
  isOpen: boolean;
  onClick: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <button
      data-cy="product-details-toggle"
      onClick={onClick}
      className="flex items-center gap-2 self-start"
    >
      <p className="font-heading font-medium">
        {isOpen ? t('readLess') : t('readMore')}
      </p>
      <div className={isOpen ? 'rotate-180' : ''}>
        <ChevronIcon height="20" width="12" stroke="black" />
      </div>
    </button>
  );
};

type Props = {
  showEditorialPolicy?: boolean;
};

const ProductDetailsTruncated = ({ showEditorialPolicy }: Props) => {
  const [showProductDetails, setShowProductDetails] = useState(false);

  const toggleProductDetails = () => setShowProductDetails(!showProductDetails);

  return (
    <div className="flex flex-col gap-6">
      <ProductDescription
        isCollapsed={!showProductDetails}
        onExpand={toggleProductDetails}
        showEditorialPolicy={showEditorialPolicy}
      />
      <ProductDetailsToggle
        isOpen={showProductDetails}
        onClick={toggleProductDetails}
      />
    </div>
  );
};

export default ProductDetailsTruncated;
